import { motion } from "framer-motion";
import { Flashlight, Camera, Scissors, ArrowRight } from "lucide-react";

// iOS-style lock screen — one rich campaign push landing from a single business.
// All props default to the Sharp & Sons marketing example so the /Reach tab still
// renders unchanged; the campaign composer overrides them to preview live copy.
export function LockScreen({
  business = "Sharp & Sons",
  message = "10% off walk-ins today only!",
  offer = null,
  accent = "#6ED0FF",
  icon: Icon = Scissors,
  date = "Tuesday, 9 June",
  time = "9:41",
}) {
  return (
    <div className="h-full w-full relative flex flex-col" style={{ background: "linear-gradient(180deg,#1d2a20 0%,#0d130e 55%,#000 100%)" }}>
      <div className="text-center pt-3">
        <div className="text-white/75 text-[13px] font-medium">{date}</div>
        <div className="text-white font-display font-bold tracking-tight" style={{ fontSize: 62, lineHeight: 1.02 }}>{time}</div>
      </div>

      {/* Hero campaign notification — pushed to bottom third like real iOS 17 lock screen */}
      <motion.div key={`${business}|${message}|${offer || ""}`} initial={{ y: 24, opacity: 0, scale: 0.96 }} animate={{ y: 0, opacity: 1, scale: 1 }} transition={{ delay: 0.15, type: "spring", stiffness: 220, damping: 20 }}
        className="mx-3 mt-auto rounded-[22px] p-3.5 flex gap-3.5 items-start"
        style={{ background: "rgba(255,255,255,0.17)", backdropFilter: "blur(16px) saturate(180%)", WebkitBackdropFilter: "blur(16px) saturate(180%)", border: "1px solid rgba(255,255,255,0.08)" }}
        data-testid="lockscreen-notification">
        <div className="h-11 w-11 rounded-[12px] grid place-items-center shrink-0" style={{ background: "#0B0D10", color: accent }}><Icon size={19} strokeWidth={2.1} /></div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between">
            <span className="text-white text-[13.5px] font-semibold truncate">{business}</span>
            <span className="text-white/55 text-[11px] shrink-0 ml-2">now</span>
          </div>
          <div className="text-white/95 text-[13.5px] leading-snug mt-0.5 font-medium line-clamp-3">{message || <span className="text-white/40 italic">Your message appears here…</span>}</div>
          {offer && (
            <div className="mt-2 inline-flex items-center gap-1.5 rounded-full bg-[#0B0D10]/50 border border-white/[0.08] px-2.5 py-1">
              <span style={{ background: accent }} className="h-1.5 w-1.5 rounded-full" />
              <span className="text-white/90 text-[10.5px] font-semibold tracking-[0.02em] uppercase">{offer}</span>
              <ArrowRight size={10} strokeWidth={2.4} className="text-white/70" />
            </div>
          )}
        </div>
      </motion.div>

      <div className="mt-3 pb-6 px-8 flex items-center justify-between">
        <div className="h-11 w-11 rounded-full grid place-items-center" style={{ background: "rgba(0,0,0,0.35)" }}><Flashlight size={18} className="text-white" fill="#fff" /></div>
        <div className="h-11 w-11 rounded-full grid place-items-center" style={{ background: "rgba(0,0,0,0.35)" }}><Camera size={18} className="text-white" /></div>
      </div>
      <div className="absolute bottom-2 left-1/2 -translate-x-1/2 h-1 w-28 rounded-full bg-white/75" />
    </div>
  );
}
